import React, { useState } from 'react';
import styled from 'styled-components';

const StyledAlert = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--error);
  color: var(--white);
  border: 0;
  padding: 0.6em 1em;
  font-weight: bold;
  font-size: 0.9rem;
  text-align: justify;
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--white);
  fill: var(--primary);
  border-radius: 50%;
  cursor: pointer;
  margin-left: 2em;
  transition: all 200ms;
  &:hover {
    box-shadow: 0 0 2px 5px rgba(0, 0, 0, 0.1);
  }
`;

function Alert({ children }) {
  const [visible, setVisible] = useState(true);

  return visible ? (
    <StyledAlert visible={visible}>
      {children}

      <IconWrapper onClick={() => setVisible(false)}>
        <svg height="20" width="20" viewBox="0 0 20 20">
          <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
        </svg>
      </IconWrapper>
    </StyledAlert>
  ) : null;
}

export default Alert;
